import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ProductModel } from 'src/app/shared/models/product.model';
import { RmaItemExModel } from 'src/app/shared/models/rma.model';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-edit-product-item',
  templateUrl: './edit-product-item.component.html',
  styleUrls: ['./edit-product-item.component.css']
})
export class EditProductItemComponent implements OnInit {

  //form : FormGroup = ProductModel.getFormGroup();
  dialogData :any;
  listProduct : ProductModel[];
  listFindProduct : ProductModel[];
  searchKey : string;
  @ViewChild('searchInput', {static: false}) searchInput :ElementRef;

  constructor(
    public service : RmaMasterService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private pservice : ProductService,
    private dialogRef: MatDialogRef<EditProductItemComponent>,
    @Inject(MAT_DIALOG_DATA) data) {

   console.log("EditProductItemComponent");
      this.dialogData = data;
   }

  ngOnInit() {
    console.log("ngOnInit");

    this.pservice.getList().subscribe(
      res=>{
        console.log("pservice.getList()");
        this.listProduct = res as ProductModel[];
        if(this.dialogData != null && this.dialogData.rmaitem != null)
        {
          this.listFindProduct = this.listProduct.filter(x => x.productId == this.dialogData.rmaitem.productId);
        }
      },
      err=>{}
      );

  }

  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create product");

    if (this.service.form.valid) {
      //if (!this.service.form.get('rmaItemId').value){ // new
        this.dialogData.rmaitem = this.service.form.value;
        this.dialogData.product = this.listProduct.filter(x => x.productId == this.service.form.value.productId)[0];
        this.dialogData.result = true;
        this.onClose();
      //}
      //else{
      //}
    }
    else{
      ////this.toastr.error("Failed to Submit", "Invalid request");
      this.gnotify.showSnackBar('Invalid request', 'Failed to Submit', "error");
    }
}

onKey(data)
  {
    this.searchKey = data;
    if(!data || data.length == 0)
    {
          this.listFindProduct = null;
    }
    else
    {
      var temp = data.toLowerCase();
      this.listFindProduct = this.listProduct.filter(x =>  x.productName.toLowerCase().includes(temp));
    }
  }

  onSearchClear()
  {
    console.log("onSearchClear");
    this.searchInput.nativeElement.value = '';
    this.searchKey = "";
    this.listFindProduct = null;
  }


}
